import React, { useEffect, useState } from "react";
import { sendRequest } from "../../util/httpClient";
import { CloseDialogContext, DialogComponent } from "../common/DialogComponent";
import OpenCaseConfirmation from "./OpenCaseConfirmation";
import NameAddress from "../Monitoring/NameAddress";
import SexOffender from "../Monitoring/SexOffender";
import IDFSexOffender from "../Monitoring/IDFSexOffender";
import SexOffenderFamilyWatchdog from "../Monitoring/SexOffenderFamilyWatchdog";
import IDFSmartSSNTracker from "../Monitoring/IDFSmartSSNTracker";
import IDFCourtRecords from "../Monitoring/IDFCourtRecords";
import IDFPaydayLoan from "../Monitoring/IDFPaydayLoan";
import { useDispatch, useSelector } from "react-redux";
import * as dashboardServiceActions from "../../store/dashboardService/actions";
import parse from "html-react-parser";
import { useHistory } from "react-router-dom";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { ApplicationState } from "../../store";
import * as alertActions from "../../store/AlertsService/actions";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../util/dateFormatting";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

interface IProps {
    alert: any;
    refresh?: any;
}
const AlertDetails = ({ alert, refresh }: IProps) => {
    const dispatch = useDispatch();
    const { t: tLang } = useTranslation();
    let isAlertStateChanged = false;
    const updateDashboardServiceData = (category: string) => dispatch(dashboardServiceActions.actionCreators.updateDashboardServiceData(category));
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const [alertDetails, setAlertDetails]: any = useState({});
    const [confirmCase, setConfirmCase] = useState(false);
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isTUAlert, setIsTUAlert] = useState(false);
    const [isBreachDetail, setIsBreachDetail] = useState(false);
    const [hasError, setHasError] = useState(false);
    let history = useHistory();
    const handleCloseDialog = (): any => {
        setShowConfirmationPopup(false);
    };
    const breachDetail = alertDetails.length && alertDetails[0]["alertBreachDetails"] ? alertDetails[0]["alertBreachDetails"] : null;
    const requestAlertDataUpdate = (alertData: any, status: string) => dispatch(alertActions.actionCreators.updateAlertsStatus(alertData, status));
    const isPrimaryAccount: boolean = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );

    useEffect(() => {
        if (isTUAlert) {
            document.querySelector<any>(`[aria-labelledby=alert-details-dialog-title]`)!.classList.add("width-lg");
        }
    }, [isTUAlert]);

    useEffect(() => {
        if (alertDetails.length) {
            for (let i = 0; i < alertDetails.length; i++) {
                if (alertDetails[i]["alertBreachDetails"] && alertDetails[i]["alertBreachDetails"]["status"] === "COMPLETED") {
                    setIsBreachDetail(true);
                    break;
                }
            }
        }
    }, [alertDetails]);

    useEffect(() => {
        if (confirmCase) {
            setLoading(true);
            const melissaVal = {
                isRead: false,
                isArchived: null,
                isOpenCased: true,
                isResolved: null,
            };
            const requestBody = {
                alertItemRequest: [
                    {
                        isIDFAlert: false,
                        alertId: alert.alertID,
                        isMelissaAlert: alert.isMelissaAlert,
                        status: "NOT_MINE",
                        serviceType: alert.serviceType,
                    },
                ],
                ...(alert.isMelissaAlert === true && { alertUpdateRequest: melissaVal }),
                isChildUser: alert.isChildUser ? alert.isChildUser : false,
                childEmailAddress: alert.childEmailAddress ? alert.childEmailAddress : "",
            };
            sendRequest("post", "api/alerts/updateAlertItem", requestBody)
                .then((data: any) => {
                    setLoading(false);
                    // refresh(true);
                    requestAlertDataUpdate(requestBody, "OPENCASE");
                    closeDialog();
                    isAlertStateChanged = true;
                    if (alertDetails[0].status != "ARCHIVED" && alertDetails[0].status != "RESOLVEDCASE") updateDashboardServiceData(alert.alertCategory);
                })
                .catch((error: any) => {
                    console.log({ error });
                });
        }
    }, [confirmCase]);

    const archiveAlert = (alert: any) => {
        setLoading(true);
        const melissaVal = {
            isRead: false,
            isArchived: true,
            isOpenCased: null,
            isResolved: null,
        };
        const requestBody = {
            alertItemRequest: [
                {
                    isIDFAlert: alert.isIDFAlert,
                    alertId: alert.alertID,
                    isMelissaAlert: alert.isMelissaAlert,
                    status: alert.isIDFAlert ? "ARCHIVED" : alert.alertStatus === "GOOD_ALERT" ? "GOOD_ALERT" : "MINE",
                    serviceType: alert.isIDFAlert ? null : alert.serviceType,
                    idfAlertType: alert.isIDFAlert ? alert.idfAlertType : null,
                },
            ],
            ...(alert.isMelissaAlert === true && { alertUpdateRequest: melissaVal }),
            isChildUser: alert.isChildUser ? alert.isChildUser : false,
            childEmailAddress: alert.childEmailAddress ? alert.childEmailAddress : "",
        };
        sendRequest("post", "api/alerts/updateAlertItem", requestBody)
            .then((data: any) => {
                setLoading(false);
                // refresh(true);
                requestAlertDataUpdate(requestBody, "ARCHIVED");
                closeDialog();
                isAlertStateChanged = true;
                updateDashboardServiceData(alert.alertCategory);
            })
            .catch((error: any) => {
                console.log({ error });
            });
    };

    const markAsReadAlert = () => {
        if (alert.alertStatus === "NEW" && alert.alertStatus !== "GOOD_ALERT") {
            setLoading(true);
            const melissaVal = {
                isRead: true,
                isArchived: false,
                isOpenCased: false,
                isResolved: false,
            };
            const requestBody = {
                alertItemRequest: [
                    {
                        isIDFAlert: alert.isIDFAlert,
                        alertId: alert.alertID,
                        isMelissaAlert: alert.isMelissaAlert,
                        status: alert.isIDFAlert ? "READ" : "NEW",
                        serviceType: alert.isIDFAlert ? null : alert.serviceType,
                        idfAlertType: alert.isIDFAlert ? alert.idfAlertType : null,
                    },
                ],
                ...(alert.isMelissaAlert === true && { alertUpdateRequest: melissaVal }),
                isChildUser: alert.isChildUser ? alert.isChildUser : false,
                childEmailAddress: alert.childEmailAddress ? alert.childEmailAddress : "",
            };
            sendRequest("post", "api/alerts/updateAlertItem", requestBody)
                .then((data: any) => {
                    setLoading(false);
                    isAlertStateChanged = true;
                    requestAlertDataUpdate(requestBody, "VIEWED");
                })
                .catch((error: any) => {
                    console.log({ error });
                });
        }
    };

    useEffect(() => {
        setLoading(true);
        const requestBody = {
            AlertData: [
                {
                    AlertID: alert.alertID,
                    ServiceType: alert.isIDFAlert ? null : alert.serviceType,
                    IDFAlertType: alert.isIDFAlert ? alert.idfAlertType : null,
                },
            ],
            isChildUser: alert.isChildUser ? alert.isChildUser : false,
            childEmailAddress: alert.childEmailAddress ? alert.childEmailAddress : "",
        };
        if(alert.isIDFAlert && alert.idfAlertType==="child-credit-activity-monitoring"){
            setAlertDetails([
                {
                  "alertId": alert.alertID,
                  "title": "Child Credit Activity Alert",
                  "createdDate": alert.createdDate,
                  "serviceType": alert.serviceType,
                  "type": "",
                  "status": alert.alertStatus,
                  "displayName": "",
                  "isOpenCase": true,
                "messageContent": {
                    "alertHelpContent": {
                      "type": "DEFAULT-CONTENT",
                      "key": "DEFAULT-MESSAGE",
                      "content": "<p>The information found may or may not accurately represent your identity. If you recognize the changes found to your credit information, you can Archive the alert (Me). If not, you can Open a Case (Not Me) and a certified Resolution Specialist will reach out to you shortly. In the meantime, we recommend that you review your credit reports and contact the institution or creditor associated with the account.</p> "
                    }
                  },
                  "alertDetails": {
                    "rawContentUrl": null,
                    "matches": null,
                    "alertItemDetails": {
                      "Activity Date": alert.createdDate
                    },
                  }
                }]);
                setLoading(false);
        } else {
        sendRequest("post", "api/alerts/getAlertDetails", requestBody)
            .then((data: any) => {
                if (data._unifiedAlertDetails.length <= 0) {
                    setHasError(true);
                } else {
                    setAlertDetails(data._unifiedAlertDetails);
                    setIsTUAlert(data._unifiedAlertDetails[0].providerItemType === "Response.TUAlertResponse.Data.Report.Record");
                    markAsReadAlert();
                }
                setLoading(false);
            })
            .catch((error: any) => {
                setHasError(true);
                setLoading(false);
            });
        }
    }, []);

    const close: any = React.useContext(CloseDialogContext);

    const closeDialog = () => {
        close("alert-details-dialog");
    };
    const navigateToSupport = () => {
        history.push("/support");
    };

    const contentForNegativeData = (): any => {
        let content: any;
        let title: any =
            alertDetails && (alertDetails[0].serviceType === "SEXOFF-FWD" || alert.idfAlertType === "sex-offender-monitoring-v2")
                ? "Please note:"
                : tLang("alerts.alerts.description.title");
        if (
            alertDetails &&
            alertDetails[0] &&
            alertDetails[0].messageContent &&
            alertDetails[0].messageContent.alertHelpContent &&
            !(alertDetails[0].serviceType === "CRDALRT" && alertDetails[0].alertDetails.rawContentUrl.length === 0)
        ) {
            // change the message content for change in Negative data of Business Credit Report
            content =
                alertDetails[0].messageContent.alertHelpContent.type === "DEFAULT-CONTENT" &&
                alertDetails[0].serviceType === "BIZCRDMON" &&
                alertDetails[0].type === "Negative data"
                    ? `<div class="negativeData"><strong><h3>${title}</h3></strong></div>
                <p >\nOne or more legal events reported on your business have been identified.<br /> <br />
                                    \nOn your <a href="/app/credit/report">Business Credit Report</a>,
                                    please review the information listed under the <strong>Legal Filing</strong>, <strong>Active Tax Liens</strong>, <strong>Active Judgements</strong>, and
                                    <strong>Uniform Commercial Code (UCC) Filings</strong> sections to ensure its accuracy. <br /> <br />
                                    \nYou may also contact your Secretary of State or your legal representative for additional legal event details.
                                    To locate the contact information for your Secretary of State, type your state followed by "Secretary of State"
                                    (ex. Maryland Secretary of State) into your preferred internet search engine.</p>`
                : (alertDetails[0].serviceType === "SVC-COAMON" || alertDetails[0].serviceType === "SVC-PUBMON")
                    ? `<div class="negativeData"><strong><h3>${title}</h3></strong></div> ${alertDetails[0].messageContent.alertHelpContent.content.replace("Identity Vault", `<a href="/app/identity-vault" style={{whiteSpace:"nowrap"}}>Identity Vault</a>`)}`
                    :(alertDetails[0].serviceType === "CreditActivityAlert" || alertDetails[0].serviceType === "ChildCreditActivityMonitoring")
                    ? `<div class="negativeData"><strong><h3>${title}</h3></strong></div>
                <p >\nIf you suspect fraudulent use of your child's SSN you should look into freezing their credit report. ${
                    !isPrimaryAccount
                        ? `The <a
                        href="/app/child-credit-activity"
                        class="default_link"
                    >
                        steps to do so can be found here.
                    </a>`
                        : ""
                }<br /><br />
                We also recommend that you contact other consumer reporting agencies as information can vary.</p>`
                    : `<div class="negativeData"><strong><h3>${title}</h3></strong></div> ${alertDetails[0].messageContent.alertHelpContent.content.replace("Transactions page", `<a href="/app/transactions/financial-account" style={{whiteSpace:"nowrap"}}>Transactions page</a>`)}`;
        }
        if (
            (breachDetail && breachDetail["status"] === "COMPLETED") ||
            (alertDetails[0].serviceType === "CRDALRT" && alertDetails[0].alertDetails.rawContentUrl.length == 0)
        ) {
            content = "";
        }
        return content;
    };

    const getNegativeData = (negativeData: any) => {
        const data = negativeData.alertDetails.alertItemDetails;
        const negativeDataType = data["New Value"].split("|")[0];
        const newValue = Boolean(parseInt(negativeDataType)) ? data["New Value"] : data["New Value"].split("|")[1];
        const previousValue = Boolean(parseInt(negativeDataType)) ? data["Previous Value"] : data["Previous Value"].split("|")[1];
        return { negativeDataType, newValue, previousValue };
    };
    const currencyFormat = (num: any) => {
        //return DFA in US number system
        return (
            "$" +
            parseInt(num)
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        );
    };
    const redirectBreachDetail = () => {
        if (breachDetail) {
            history.push({
                pathname: `/breaches/breach-details`,
                state: {
                    id: breachDetail["breachId"],
                    backPage: "breach_alert",
                    orgName: breachDetail["organizationName"],
                    breachDate: breachDetail["breachDate"],
                },
            });
        }
    };
    return (
        <React.Fragment>
            {hasError ? (
                <>
                    <div className="row" style={{ minHeight: "170px" }}>
                        <div className="box" style={{ backgroundColor: "#F2F6F9" }}>
                            <div className="box-header col-xs-12 col-sm-12">
                                <div className="content-sub-title text-align-center">
                                    <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                        <em className="las la-exclamation-circle "></em>
                                    </div>
                                </div>
                            </div>
                            <div className="box-content text-align-center">
                                <p>
                                    We are facing issue while fetching alert details, please try again later. If you still face the issue, please contact our
                                    support team.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="dialog-footer" style={{ paddingTop: breachDetail && breachDetail["status"] === "COMPLETED" ? "unset" : "1.5rem" }}>
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-link" onClick={() => closeDialog()}>
                                    <span className="btn-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.Close")}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="dialog-header">
                        {!["GOOD_ALERT", "GOOD_ALERT_MINE"].includes(alert.alertStatus) ? (
                            <div className="dialog-icon status-alert">
                                <em className="las la-exclamation-triangle"></em>
                            </div>
                        ) : (
                            <div className="dialog-icon status-good-alert">
                                <RenderIcons iconName="shield-with-checkmark" color="#ffff" />
                            </div>
                            )}
                        <h1>
                            {alertDetails[0] &&
                                alertDetails[0].messageContent &&
                                ((alertDetails[0].title && (isBusinessUser ? "Business " : "") + alertDetails[0].title) ||
                                    (alert.isIDFAlert && alertDetails[0].type && (isBusinessUser ? "Business " : "") + alertDetails[0].type))}
                        </h1>
                        <div className="alert-date">
                            {tLang("alerts.alerts.activeAlertPopup.buttonText.createdOn")}{" "}
                            {alertDetails[0] && alertDetails[0]["createdDate"] && getFormattedDate(i18nService.get("Country"), alertDetails[0]["createdDate"])}
                        </div>
                    </div>
                    <div className={`dialog-body ${loading && "loading"}`}>
                        {!(alertDetails[0] && alertDetails[0].serviceType === "CRDALRT" && alertDetails[0].alertDetails.rawContentUrl.length === 0) ? (
                            <p>
                                {alertDetails[0] && alertDetails[0].messageContent && alertDetails[0].messageContent.introMessageAlert}
                                {alertDetails[0] && alertDetails[0].messageContent && alertDetails[0].messageContent.tooltip && (
                                    <span className="tooltip-container">
                                        <span className="btn-icon">
                                            <em className="las la-exclamation-circle"></em>
                                        </span>
                                        <span className="tooltip-text">{alertDetails[0].messageContent.tooltip}</span>
                                    </span>
                                )}
                            </p>
                            ) : null}
                        {!!partnerLanguageOptions && partnerLanguageOptions.length > 1 && (
                                <p><strong>{tLang("alerts.alerts.alertsDisclaimer.title")}:</strong>{" "}{tLang("alerts.alerts.alertsDisclaimer.message")}</p>
                        )}
                        
                        {alertDetails[0] &&
                        alertDetails[0].messageContent &&
                        (alertDetails[0].type !== "Negative data" || alertDetails[0].messageContent.alertHelpContent.type !== "DEFAULT-CONTENT") ? (
                            <>
                                {breachDetail && isBreachDetail ? (
                                    <div className="data-row row breach-alert-title-main">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <h5 className="breach-alert-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.detialSummary")}</h5>
                                        </div>
                                        <div className="col-xs-12 col-sm-8 col-no-gutter text-align-sm-end text-align-right">
                                            <button
                                                className="btn-default btn-breach-primary breach-alert-btn-width btn-search-bg-color"
                                                onClick={redirectBreachDetail}
                                            >
                                                View Full Breach Alert
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    !["GOOD_ALERT", "GOOD_ALERT_MINE"].includes(alert.alertStatus) && (
                                        <h3 className="content-sub-title margin-bottom-xs">{tLang("alerts.alerts.activeAlertPopup.buttonText.detialSummary")}</h3>
                                    )
                                )}

                                <div className="alert-details-container" id="alert1-details">
                                    <div role="grid" className="data-grid has-lines row-height-sm" id="alert1-details-content" aria-hidden="false">
                                        {alert.serviceType === "SEXOFF" ||
                                        alert.serviceType === "SVC-COAMON" ||
                                        alert.idfAlertType?.startsWith("sex-offender-monitoring")
                                            ? alertDetails[0] && <SexOffender alertInfo={alertDetails} />
                                            : alertDetails[0] && <NameAddress alertInfo={alertDetails} isTUAlert={isTUAlert} isBreachDetail={isBreachDetail} />}
                                        {alert.idfAlertType?.startsWith("sex-offender-monitoring") && alertDetails[0] && (
                                            <IDFSexOffender alertInfo={alertDetails} />
                                        )}
                                        {alert.serviceType === "SEXOFF-FWD" && alertDetails[0] && <SexOffenderFamilyWatchdog alertInfo={alertDetails} />}
                                        {(alert.serviceType === "SEXOFF" || alert.idfAlertType?.startsWith("sex-offender-monitoring")) &&
                                        breachDetail &&
                                        breachDetail["status"] === "COMPLETED" ? (
                                            <NameAddress alertInfo={alertDetails} isTUAlert={isTUAlert} isBreachDetail={isBreachDetail} />
                                        ) : null}
                                        {alert.idfAlertType === "smart-ssn-tracker" && alertDetails[0] && <IDFSmartSSNTracker alertInfo={alertDetails} />}
                                        {alert.idfAlertType === "court-records-monitoring" && alertDetails[0] && <IDFCourtRecords alertInfo={alertDetails} />}
                                        {alert.idfAlertType === "payday-loan" && alertDetails[0] && <IDFPaydayLoan alertInfo={alertDetails} />}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                {alertDetails[0] &&
                                    alertDetails[0].alertDetails.alertItemDetails &&
                                    Boolean(alertDetails[0].alertDetails.alertItemDetails["New Value"]) &&
                                    Boolean(alertDetails[0].alertDetails.alertItemDetails["Previous Value"]) && (
                                        <>
                                            <h3 className="content-sub-title margin-bottom-xs">
                                                There has been a change in your Derogatory Filing
                                                {getNegativeData(alertDetails[0]).negativeDataType === "DFA" ? " Amount (DFA)." : " Count (DFC)."}
                                            </h3>

                                            <div className="alert-details-container" id="alert1-details" style={{ marginBottom: "40px" }}>
                                                <div role="grid" className="data-grid has-lines row-height-sm" id="alert1-details-content" aria-hidden="false">
                                                    <div role="row" className="data-row row">
                                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                            <div className="data-label" id="alert1-prevValue">
                                                                Previous Value
                                                            </div>
                                                        </div>
                                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                            <div className="data-value" aria-labelledby="alert1-prevValue">
                                                                {getNegativeData(alertDetails[0]).negativeDataType === "DFA"
                                                                    ? currencyFormat(getNegativeData(alertDetails[0]).previousValue)
                                                                    : getNegativeData(alertDetails[0]).previousValue}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div role="row" className="data-row row">
                                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                            <div className="data-label" id="alert1-newValue">
                                                                New Value
                                                            </div>
                                                        </div>
                                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                            <div className="data-value" aria-labelledby="alert1-newValue">
                                                                {getNegativeData(alertDetails[0]).negativeDataType === "DFA"
                                                                    ? currencyFormat(getNegativeData(alertDetails[0]).newValue)
                                                                    : getNegativeData(alertDetails[0]).newValue}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {getNegativeData(alertDetails[0]).negativeDataType === "DFA" ? (
                                                <span style={{ marginTop: "50px" }}>
                                                    <strong>Derogatory Filing Amount (DFA)</strong> is the total sum of all legal filings past due.
                                                </span>
                                            ) : (
                                                <span style={{ marginTop: "50px" }}>
                                                    <strong>Derogatory Filing Count (DFC)</strong> is the total count of all legal filings.
                                                </span>
                                            )}
                                        </>
                                    )}
                            </>
                            )}                           

                            {alertDetails[0] && alertDetails[0]?.messageContent && alertDetails[0]?.messageContent?.alertHelpContent && alertDetails[0]?.messageContent?.alertHelpContent?.content  && (
                            <>
                                {contentForNegativeData().indexOf("<ol>") !== -1 ? (
                                    <>
                                        <div
                                            style={{ marginTop: "40px" }}
                                            dangerouslySetInnerHTML={{ __html: `${contentForNegativeData().split("<ol>")[0]}</p>` }}
                                        ></div>
                                        <ol style={{ listStyleType: "decimal", paddingLeft: "10px", paddingBottom: "10px" }}>
                                            {contentForNegativeData()
                                                .split("<ol>")[1]
                                                .split("</ol>")[0]
                                                .split("</li>")
                                                .map((liElement: any) => liElement.length > 0 && parse(liElement, {}))}
                                        </ol>
                                        <div dangerouslySetInnerHTML={{ __html: `<p>${contentForNegativeData().split("<ol>")[1].split("</ol>")[1]}` }}></div>
                                    </>
                                ) : breachDetail && breachDetail["status"] === "COMPLETED" ? null : (
                                    <div
                                        style={{ marginTop: "40px" }}
                                        dangerouslySetInnerHTML={{
                                            __html: `<p>${
                                                alertDetails[0] &&
                                                alertDetails[0]?.messageContent &&
                                                alertDetails[0]?.messageContent?.alertHelpContent &&
                                                contentForNegativeData()
                                            }</p>`,
                                        }}
                                    ></div>
                                )}
                                </>
                        )}
                    </div>
                    <div className="dialog-footer" style={{ paddingTop: breachDetail && breachDetail["status"] === "COMPLETED" ? "unset" : "1.5rem" }}>
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-link" onClick={() => closeDialog()}>
                                    <span className="btn-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.Close")}</span>
                                </button>
                            </div>
                            {breachDetail && breachDetail["status"] === "COMPLETED" ? null : (
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    {alert.alertStatus !== "ARCHIVED" && alert.alertStatus !== "GOOD_ALERT_MINE" && alert.alertStatus !== "Archived" && (
                                        <button
                                            type="button"
                                            className="btn-default btn-primary-outline"
                                            onClick={() => archiveAlert(alert)}
                                            style={{ marginRight: "10px" }}
                                        >
                                            <span className="btn-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.archive")}</span>
                                        </button>
                                    )}
                                    {alert.isMelissaAlert === true
                                        ? (alert.alertStatus !== "Viewed" || alert.alertStatus === "Viewed") && (
                                              <button onClick={() => setShowConfirmationPopup(true)} type="button" className="btn-default btn-primary-outline">
                                                  <span className="btn-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.openacase")}</span>
                                              </button>
                                          )
                                        : alert.serviceType !== "SEXOFF" &&
                                          alert.alertStatus !== "GOOD_ALERT" &&
                                          alert.alertStatus !== "GOOD_ALERT_MINE" &&
                                          alert &&
                                          !alert.isIDFAlert &&
                                          alertDetails[0] &&
                                          alertDetails[0]["isOpenCase"] && (
                                              <button onClick={() => setShowConfirmationPopup(true)} type="button" className="btn-default btn-primary-outline">
                                                  <span className="btn-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.openacase")}</span>
                                              </button>
                                          )}
                                    {alert &&
                                        alert.isIDFAlert &&
                                        alert.serviceType !== "SEXOFF" &&
                                        !alert.idfAlertType?.startsWith("sex-offender-monitoring") &&
                                        alertDetails[0] &&
                                        alertDetails[0]["isOpenCase"] && (
                                            <button onClick={() => navigateToSupport()} type="button" className="btn-default btn-primary-outline">
                                                <span className="btn-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.openacase")}</span>
                                            </button>
                                        )}
                                    {alertDetails[0] && alertDetails[0].serviceType?.startsWith("social-media-monitoring") && (
                                        <button onClick={() => navigateToSupport()} type="button" className="btn-default btn-primary-outline">
                                            <span className="btn-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.openacase")}</span>
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
            {showConfirmationPopup && (
                <DialogComponent hideCloseButton={true} dialogId="open-case-confirmation" title="Alert Details" closeDialog={handleCloseDialog}>
                    <OpenCaseConfirmation type={"openCase"} setConfirmCase={setConfirmCase}></OpenCaseConfirmation>
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default AlertDetails;
